// leverage.js
import HTTP from "@/_helpers/http";
import { LEVELUNLOCKSETTINGS__API } from "@/_helpers/urls";
import { LEVELUNLOCKSETTINGS__MUTATIONS } from "../mutation-types";
import { LEVELUNLOCKSETTINGS__ACTIONS } from "../action-types";
import toast from "@/services/Notification";

// State
const state = {
    settings: [],
    partnersettings: [],
};

// Getters
const getters = {};

// Mutations
const mutations = {
    [LEVELUNLOCKSETTINGS__MUTATIONS.LEVELUNLOCKSETTINGS](state, data) {
        state.settings = data.settings;
    },
    [LEVELUNLOCKSETTINGS__MUTATIONS.PARTNERLEVELUNLOCKSETTINGS](state, data) {
        state.partnersettings = data.settings;
    },
};

// Actions
const actions = {
    async [LEVELUNLOCKSETTINGS__ACTIONS.LEVELUNLOCKSETTINGS]({ commit }) {
        try {
            const url = `${LEVELUNLOCKSETTINGS__API.LEVELUNLOCKSETTINGS}`;
            const response = await HTTP().get(url);
            commit(LEVELUNLOCKSETTINGS__MUTATIONS.LEVELUNLOCKSETTINGS, response.data);
        } catch (error) {
            console.log(error);
        }
    },
    async [LEVELUNLOCKSETTINGS__ACTIONS.PARTNERLEVELUNLOCKSETTINGS]({ commit }, id) {
        try {
            const url = `${LEVELUNLOCKSETTINGS__API.PARTNERLEVELUNLOCKSETTINGS}?partner_id=${id}`;
            const response = await HTTP().get(url);
            commit(LEVELUNLOCKSETTINGS__MUTATIONS.PARTNERLEVELUNLOCKSETTINGS, response.data);
        } catch (error) {
            console.log(error);
        }
    },
    async [LEVELUNLOCKSETTINGS__ACTIONS.POSTLEVELUNLOCKSETTINGS]({ dispatch }, data) {
        try {
            const url = `${LEVELUNLOCKSETTINGS__API.POSTLEVELUNLOCKSETTINGS}`;
            const response = await HTTP().post(url, data);
            if (response.status === 200) {
                toast.success(response.data.message || "Updated")
                dispatch(LEVELUNLOCKSETTINGS__ACTIONS.LEVELUNLOCKSETTINGS);
            }
        } catch (error) {
            console.log(error);
            toast.error(error.response.data.message || "Update failed")
        }
    },
    async [LEVELUNLOCKSETTINGS__ACTIONS.POSTPARTNERLEVELUNLOCKSETTINGS]({ dispatch }, data) {
        try {
            console.log(data)
            const url = `${LEVELUNLOCKSETTINGS__API.POSTPARTNERLEVELUNLOCKSETTINGS}?partner_id=${data?.id}`;
            const response = await HTTP().post(url, { settings: data?.settings });
            if (response.status === 200) {
                toast.success(response.data.message || "Updated")
                dispatch(LEVELUNLOCKSETTINGS__ACTIONS.PARTNERLEVELUNLOCKSETTINGS, data?.id);
            }
        } catch (error) {
            console.log(error);
            toast.error(error.response.data.message || "Update failed")
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
